import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";

type BatchTranslateTemplatesVariables = {templateIds: number[]};

const batchTranslateTemplates = async ({templateIds}: BatchTranslateTemplatesVariables): Promise<void> => {
  await axiosReachInstance.post<void>("/templates/batch-translate", {template_ids: templateIds});
};

export const useBatchTranslateTemplates = (
  options?: BaseMutationOptions<void, BatchTranslateTemplatesVariables>
): BaseUseMutationResult<void, BatchTranslateTemplatesVariables> => {
  return useBaseMutation<void, BatchTranslateTemplatesVariables>(batchTranslateTemplates, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY]],
  });
};
